module.exports = __webpack_public_path__ + "stylesheets/wave-projects_54184c5f320836a52d9763a4bf662678.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/wave/wave-projects.less
// module id = 15vf
// module chunks = 151